import React, { FC } from 'react';
import cls from './MonthMode.module.css';
import classNames from 'classnames';
import { MonthModeHeader } from './MonthModeHeader/MonthModeHeader';
import { MonthModeBody } from './MonthModeBody/MonthModeBody';

export const MonthMode = ({ stages, classes, isBlur }) => {
    return (
        <div className={classNames(cls.MonthMode, { [classes]: isBlur })}>
            <MonthModeHeader />
            <MonthModeBody stages={stages} />
        </div>
    );
};
